<template>

  <div class="d-container sendi-admin-entry">

    <div class="d-content select-login">

      <div class="login-header text-center">

        <span class="title-login">
          <img class="logo-login" src="/static/img/sendi-logo.png" width="400" height="78" alt="Sendi">
        </span>

        <h1 class="sendi-admin-title">Portal de administración</h1><p class="sub-login">Selecciona el tipo de usuario</p>

      </div>

      <div class="f">

        <div class="f-content" @click="toAdminLogin">

          <div class="h">

            <div class="f-data-icon" id="administrador"></div>

            <div class="f-data-text">

              <p>Administrador</p>

            </div>

            <div class="buttom-f text-center">

              <button type="button" id="admin-access" aria-label="Acceder como administrador" :class="'btn btn-primary  btn-block btn-round btn-welcome '" >Continuar</button>

            </div>

          </div>

        </div>

        <div class="f-content" @click="toOperLogin">

          <div class="h">

            <div class="f-data-icon" id="operador-envio"></div>

            <div class="f-data-text">

              <p>Operador de envío/recepción</p>

            </div>

            <div class="buttom-f text-center">

              <button type="button" id="operator-access" aria-label="Acceder como operador de envío o recepción" :class="'btn btn-primary  btn-block btn-round btn-welcome '" >Continuar</button>

            </div>

          </div>

        </div>

        <!--<div class="f-content" @click="toClientLogin">

          <div class="h">

            <div class="f-data-icon" id="cliente"></div>

            <div class="f-data-text">

              <p>Cliente</p>

            </div>

            <div class="buttom-f text-center">
              <button type="submit" id="submit" :class="'btn btn-primary btn-block btn-round btn-welcome '" >Continuar</button>
            </div>



          </div>

        </div>-->

      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: 'LoginSelection',
  data() {
    return {}
  },
  methods: {
    toAdminLogin() {
      this.$router.push('/login/admin')
    },
    toOperLogin() {
      this.$router.push('/login/oper')
    },
    toClientLogin() {
      this.$router.push('/login/client')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// LoginSelection.vue?5b519fb6